import { useEffect, useState } from "react";
import { loadVgsCollect } from "@lib/vgs/loadVgsCollect";
import type { VgsConfig } from "@lib/vgs/vgsConfig";

export type VgsCollectStatus = "loading" | "ready" | "failed";

export function useVgsCollectStatus({
    vaultId,
    environment,
    collectVersion,
    collectIntegrity,
}: VgsConfig): VgsCollectStatus {
    const [status, setStatus] = useState<VgsCollectStatus>("loading");

    useEffect(
        function loadCollectScript() {
            let isCurrent = true;
            loadVgsCollect({
                vaultId,
                environment,
                collectVersion,
                collectIntegrity,
            }).then(
                () => {
                    if (isCurrent) {
                        setStatus("ready");
                    }
                },
                () => {
                    if (isCurrent) {
                        setStatus("failed");
                    }
                },
            );
            return () => {
                isCurrent = false;
            };
        },
        [vaultId, environment, collectVersion, collectIntegrity],
    );

    return status;
}
